<template>
  <div>
    <h5>Preview</h5>
    <b-row class="justify-content-md-center border-bottom border-top mb-2 mt-2 pt-2">
      <b-col lg="6">
        <statistic-card-horizontal
          :panelconfig="panelconfig"
        />
      </b-col>
    </b-row>

    <h5>Layout</h5>

    <b-form @submit.prevent>
      <!-- Icon -->
      <b-col class="mb-2">
        <h6>Icon</h6>
        <v-select
          v-model="panelconfig.icon"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-col>
      <!-- Color -->
      <b-col class="mb-2">
        <h6>Color</h6>
        <v-select
          v-model="panelconfig.color"
          title="Color"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="colors"
        />
      </b-col>
      <b-col class="border-bottom" />
      <data-source-picker
        :panelconfig="panelconfig"
        :max-data-sources="1"
      />

    </b-form>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import DataSourcePicker from '@core/components/data-source-picker/DataSourcePicker.vue'
import StatisticCardHorizontal from './StatisticCardHorizontal.vue'

export default {
  components: {
    BCol,
    BForm,
    BRow,
    vSelect,
    StatisticCardHorizontal,
    DataSourcePicker,
  },
  props: {
    panelconfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colors: [
        'primary', 'success', 'info', 'warning', 'danger',
      ],
      option: [
        { title: 'CPU Icon', id: 'CpuIcon' },
        { title: 'Square Icon', id: 'SquareIcon' },
        { title: 'Battery Icon', id: 'BatteryIcon' },
      ],
    }
  },
}
</script>

<style lang="scss">
.hover {
  background-color: rgba(45, 177, 85, 0.153); /* Black background with opacity */
  z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.highlight{
   background-color: rgba(45, 177, 85, 0.594);
}
</style>
